import Page from "../../components/Page";
import usePendingList from "./hooks/usePendingList";

const PendingList = () => {
  const page = usePendingList();
  return <Page {...page} />;
};

export default PendingList;
